export const getAccessToken = (): string | null => localStorage.getItem('access_token');
export const setAccessToken = (token: string): void => localStorage.setItem('access_token', token);
export const clearAccessToken = (): void => localStorage.removeItem('access_token');

export type StoredUser = unknown;

export const getUser = (): StoredUser | null => {
  const raw = localStorage.getItem('user_data');
  return raw ? (JSON.parse(raw) as StoredUser) : null;
};
export const setUser = (user: StoredUser): void => localStorage.setItem('user_data', JSON.stringify(user));
export const clearUser = (): void => localStorage.removeItem('user_data');
